import { render, staticRenderFns } from "./ManualReleaseDialog.vue?vue&type=template&id=39091e80&scoped=true"
import script from "./ManualReleaseDialog.vue?vue&type=script&lang=js"
export * from "./ManualReleaseDialog.vue?vue&type=script&lang=js"
import style0 from "./ManualReleaseDialog.vue?vue&type=style&index=0&id=39091e80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39091e80",
  null
  
)

export default component.exports